import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaSkype,
  FaTelegram,
  FaTiktok,
} from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { notFound } from "../../../../enums/mainEnums";
import { Box } from "@mui/material";

const ContactData = ({ data }) => {
  const haveAnyData = () => {
    return (
      data?.sex !== notFound ||
      data?.about !== notFound ||
      data?.description !== notFound ||
      data?.skype !== notFound ||
      data?.whatsapp !== notFound ||
      data?.telegram !== notFound ||
      data?.tiktok !== notFound ||
      data?.instagram !== notFound ||
      data?.facebook !== notFound
    );
  };
  return (
    <Box sx={{ p: 3 }}>
      {!haveAnyData() ? (
        <div className="text-start">There are no data yet</div>
      ) : (
        <div className="user-contact-data w-full flex flex-col items-start justify-center gap-4">
          {data?.skype !== notFound && (
            <a
              href={data?.skype}
              className="hover:opacity-80 flex gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaSkype size={"1.5rem"} />{" "}
              <div className="item w-48 text-start truncate hover:opacity-70">
                {data?.skype}
              </div>
            </a>
          )}
          {data?.whatsapp !== notFound && (
            <a
              href={data?.whatsapp}
              className="hover:opacity-80 flex gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BsWhatsapp size={"1.5rem"} />{" "}
              <div className="item w-48 text-start truncate hover:opacity-70">
                {data?.whatsapp}
              </div>
            </a>
          )}
          {data?.telegram !== notFound && (
            <a
              href={data?.telegram}
              className="hover:opacity-80 flex gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTelegram size={"1.5rem"} />{" "}
              <div className="item w-48 text-start truncate hover:opacity-70">
                {data?.telegram}
              </div>
            </a>
          )}
          {data?.tiktok !== notFound && (
            <a
              href={data?.tiktok}
              className="hover:opacity-80 flex gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTiktok size={"1.5rem"} />{" "}
              <div className="item w-48 text-start truncate hover:opacity-70">
                {data?.tiktok}
              </div>
            </a>
          )}
          {data?.instagram !== notFound && (
            <a
              href={data?.instagram}
              className="hover:opacity-80 flex gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={"1.5rem"} />{" "}
              <div className="item w-48 text-start truncate hover:opacity-70">
                {data?.instagram}
              </div>
            </a>
          )}
          {data?.facebook !== notFound && (
            <a
              href={data?.facebook}
              className="hover:opacity-80 flex gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={"1.5rem"} />{" "}
              <div className="item w-48 text-start truncate hover:opacity-70">
                {data?.facebook}
              </div>
            </a>
          )}
        </div>
      )}
    </Box>
  );
};

export default ContactData;
